/**
 * FEATURE FLAGS
 * =============
 * Per-user feature flags stored in Firestore on the user's profile document.
 *
 * To enable a flag for a user:
 *   Firebase Console → /users/{uid} → set featureFlags.FLAG_NAME: true
 *
 * These flags are temporary — remove once the feature is stable and rolled out to all users.
 */

export enum FeatureFlag {
  MULTI_COMPANY = 'MULTI_COMPANY',
  NEW_MENU = 'NEW_MENU',
}
